import { createSlice } from '@reduxjs/toolkit';
export var cupsInitialState = {
    availableCup: [],
};
export var cupsSlice = createSlice({
    name: 'cups',
    initialState: cupsInitialState,
    reducers: {
        setAvailableCup: function (state, action) {
            var _a;
            state.availableCup = (_a = action.payload) !== null && _a !== void 0 ? _a : [];
        },
    },
});
export var setAvailableCup = cupsSlice.actions.setAvailableCup;
